import { Utils } from 'cc-common';
import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../../_models/user-name-display-result-dto';

export class WorkflowVendorEditResultDto {
    managementCompanyId: number;
    managementCompany: string;
    location: string;
    communityId: number;
    community: string;
    workflowId: number;
    invoiceNumber: string;

    @Type(() => Date)
    invoiceDate: Date;
    invoiceAmount: number;
    workflowStatus: string;
    workflowName: string;
    payee: string;
    payeeType: string;
    payeeCode: string;
    specialHandling: string;

    @Type(() => Date)
    dueDate: Date;

    @Type(() => Date)
    workflowStartDate: Date;

    eft: boolean;
    invoiceStatus: string;

    @Type(() => UserNameDisplayResultDto)
    dashboardResponsibleUsers: Array<UserNameDisplayResultDto>;

    dashboardStatus: string;
    hasNotes: boolean;
    hasBoardNotes: boolean;
    boardApprovalEnabled: boolean;

    @Type(() => Date)
    communityTerminationDate: Date;
    allowEdit: boolean;
    allowDelete: boolean;

    get responsibleUsers(): string {
        return Utils.notNullAndDefined(this.dashboardResponsibleUsers)
            ? this.dashboardResponsibleUsers.map((r) => r.displayName).join(', ')
            : '';
    }

    get managementCompanyDisplayText(): string {
        return Utils.notNullOrEmpty(this.managementCompany) ? this.managementCompany : null;
    }
}
